(function () {
  var HIDE_RULES =
    '[data-testid="form-header"],' +
    '[data-testid="form-title"],' +
    '[data-testid="form-description"],' +
    '[class*="FormHeader"],' +
    '[class*="formHeader"] {' +
    'display: none !important;' +
    'height: 0 !important;' +
    'margin: 0 !important;' +
    'padding: 0 !important;' +
    'overflow: hidden !important;' +
    'visibility: hidden !important;' +
    '}';

  function registerFormStyles() {
    window.formStyles = window.formStyles || new Map();
    window.formStyles.set('event-forms-hide-header', HIDE_RULES);
  }

  function hideLightDomHeader(container) {
    if (!container || container.dataset.eventFormHeaderHidden === 'true') return;

    var header = container.querySelector('[data-testid="form-header"]');
    if (header) {
      header.hidden = true;
      header.style.display = 'none';
      container.dataset.eventFormHeaderHidden = 'true';
      return;
    }

    var children = container.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child.tagName === 'FORM') continue;
      if (child.querySelector('input, textarea, select, button[type="submit"]')) continue;
      if (child.querySelector('h1, h2, h3, p')) {
        child.hidden = true;
        child.style.display = 'none';
        container.dataset.eventFormHeaderHidden = 'true';
        return;
      }
    }
  }

  function hideShadowHeader(embed) {
    if (!embed || !embed.shadowRoot || embed.dataset.eventFormHeaderHidden === 'true') return;

    var style = document.createElement('style');
    style.textContent = HIDE_RULES;
    embed.shadowRoot.appendChild(style);
    embed.dataset.eventFormHeaderHidden = 'true';
  }

  function processCards() {
    document.querySelectorAll('.event-form-section__card').forEach(function (card) {
      card.querySelectorAll('section[data-testid="form-container"]').forEach(hideLightDomHeader);
      card.querySelectorAll('shopify-forms-embed, form-embed').forEach(hideShadowHeader);
    });
  }

  registerFormStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processCards);
  } else {
    processCards();
  }

  new MutationObserver(processCards).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
